import "@fontsource/exo/400.css";
import "@fontsource/exo/500.css";
import "@fontsource/exo/600.css";
import "@fontsource/exo/700.css";
import "@fontsource/open-sans/300.css";
import "@fontsource/open-sans/500.css";
import "@fontsource/open-sans/700.css";

import React, { useState, useEffect } from "react";
import { Auth } from "aws-amplify";
import { ChakraProvider } from "@chakra-ui/react";
import theme from "./theme";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { useLogin } from "./hooks/useLogin";
import "./App.css";
import { MainPage } from "./pages/MainPage";
import { SignInPage } from "./pages/SignInPage";
import { ForgotPasswordPage } from "./pages/ForgotPasswordPage";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoggedin, user, isChecking] = useLogin();
  const [userRole, setUserRole] = useState("Teacher");

  useEffect(() => {
    if (isLoggedin) {
      setIsAuthenticated(true);
      setUserRole(user?.userRole[0]?.role);
    }
  }, [isLoggedin, user]);

  return (
    <ChakraProvider theme={theme}>
      {!isChecking && (
        <Router>
          {isAuthenticated ? (
            <MainPage user={user} userRole={userRole} Auth={Auth} />
          ) : (
            <Switch>
              <Route path="/">
                <SignInPage />
              </Route>
              <Route path="/forgetpassword">
                <ForgotPasswordPage />
              </Route>
            </Switch>
          )}
        </Router>
      )}
    </ChakraProvider>
  );
}

export default App;
